import type { Model } from '@src/service/model/base'

interface RawWebhookIntegration {
  id: string
  readonly type: 'webhook'
  orgId: string | null
  userId: string | null
  url: string | null
  method: 'post' | 'get' | 'put' | null
}

export class WebhookIntegrationModel implements Model {
  private raw: RawWebhookIntegration

  constructor(attrs: Partial<RawWebhookIntegration> = {}) {
    this.raw = {
      id: '',
      type: 'webhook',
      orgId: null,
      userId: null,
      url: null,
      method: null,
    }

    this.deserialize(attrs)
  }

  get id(): string {
    return this.raw.id
  }

  get type(): 'webhook' {
    return this.raw.type
  }

  get orgId(): string | null {
    return this.raw.orgId
  }

  get userId(): string | null {
    return this.raw.userId
  }

  get url(): string | null {
    return this.raw.url
  }

  get method(): 'post' | 'get' | 'put' | null {
    return this.raw.method
  }

  deserialize = (json: Partial<RawWebhookIntegration>) => {
    Object.assign(this.raw, json)
    return this
  }

  serialize = (): RawWebhookIntegration => {
    return {
      id: this.id,
      type: this.type,
      orgId: this.orgId,
      userId: this.userId,
      url: this.url,
      method: this.method,
    }
  }
}

export const isWebhookIntegrationModel = (a: unknown): a is WebhookIntegrationModel => {
  return a instanceof WebhookIntegrationModel
}
